import { Link } from "react-router-dom";
import { ArrowUpRight, Flame, Soup } from "lucide-react";
import { Reveal } from "@/components/site/Primitives";

const Panel = ({ dark, icon: Icon, eyebrow, title, text, img, items, cta, testid }) => (
  <Reveal className="h-full">
    <article
      data-testid={testid}
      className={`group relative h-full overflow-hidden rounded-lg border ${dark ? "bg-[#1F1411] border-[#D4AF37]/25 text-[#FDFBF7]" : "bg-[#F3EDE2] border-[#E5DCD0] text-[#1A1513]"}`}
    >
      <div className="img-zoom relative h-72 sm:h-96 overflow-hidden">
        <img src={img} alt={title} className="h-full w-full object-cover" />
        <div className={`absolute inset-0 ${dark ? "bg-gradient-to-t from-[#1F1411] via-[#1F1411]/20" : "bg-gradient-to-t from-[#F3EDE2] via-transparent"} to-transparent`} />
      </div>
      <div className="relative p-8 sm:p-10 -mt-16">
        <div className={`inline-grid place-items-center h-12 w-12 rounded-full ${dark ? "bg-[#D4AF37] text-[#140D0B]" : "bg-[#1A1513] text-[#D4AF37]"}`}><Icon size={22} /></div>
        <p className={`eyebrow mt-6 ${dark ? "" : "!text-[#9E7B27]"}`}>{eyebrow}</p>
        <h3 className="mt-3 font-serif-ym text-3xl sm:text-4xl font-semibold leading-tight">{title}</h3>
        <p className={`mt-4 leading-relaxed ${dark ? "text-[#CBBBAE]" : "text-[#6B5E56]"}`}>{text}</p>
        <ul className="mt-6 flex flex-wrap gap-2">
          {items.map((i) => (
            <li key={i} className={`rounded-full px-3 py-1 text-xs border ${dark ? "border-[#D4AF37]/30 text-[#E5C158]" : "border-[#1A1513]/15 text-[#1A1513]"}`}>{i}</li>
          ))}
        </ul>
        <Link to={cta.to} className={`mt-8 inline-flex items-center gap-2 text-sm font-semibold ${dark ? "text-[#D4AF37]" : "text-[#C84B31]"} group-hover:gap-3 transition-[gap]`} data-testid={`${testid}-cta`}>
          {cta.label} <ArrowUpRight size={16} />
        </Link>
      </div>
    </article>
  </Reveal>
);

export function Gastronomy() {
  return (
    <section id="lezzetler" className="bg-[#FAF7F2] py-24 sm:py-32" data-testid="gastronomy-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-3xl">
          <p className="eyebrow !text-[#9E7B27] mb-4">İki Mutfak, Tek Sofra</p>
          <h2 className="font-serif-ym text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#1A1513] leading-[1.02]">
            Ev sıcaklığında tencere yemekleri, <em className="text-[#9E7B27]">usta işi</em> premium ızgaralar.
          </h2>
        </Reveal>
        <div className="mt-16 grid lg:grid-cols-12 gap-6 lg:gap-8 items-start">
          <div className="lg:col-span-6">
            <Panel
              testid="panel-ev-yemekleri"
              icon={Soup}
              eyebrow="Her gün taze"
              title="Ev Yemekleri"
              text="Sabahın erken saatinde ocağa konan tencereler; kuru fasulyeden et soteye, mercimek çorbasından fırın musakkaya kadar anne eli değmiş gibi."
              img="/images/fasulye.jpg"
              items={["Kuru Fasulye", "Et Sote", "Tas Kebabı", "Mercimek Çorbası"]}
              cta={{ to: "/menu#ev-yemekleri", label: "Ev yemeklerini gör" }}
            />
          </div>
          <div className="lg:col-span-6 lg:mt-24">
            <Panel
              dark
              testid="panel-premium"
              icon={Flame}
              eyebrow="Usta tavsiyesi"
              title="Premium Izgaralar"
              text="Özenle seçilmiş, dinlendirilmiş etler odun ateşinin karakteriyle buluşuyor. Karışık ızgaradan dana antrikota, kuzu şişten kokoreçe imza tabaklarımız."
              img="/images/karisik.jpg"
              items={["Karışık Izgara", "Dana Antrikot", "Kuzu Şiş", "Kokoreç"]}
              cta={{ to: "/menu#premium-izgaralar", label: "Premium menüyü keşfet" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
